/**
 * Formats a date string into a shortened display format
 *
 * @param dateString - The input date string to format (e.g. "15 December 2023")
 * @param maxParts - Maximum number of date parts to include (1-3)
 * @returns Formatted date string
 * @example
 * translateDate("15 December 2023", 1) // returns "15"
 * translateDate("15 December 2023", 2) // returns "15 Dec"
 * translateDate("15 December 2023", 3) // returns "15 Dec 2023"
 */
export function translateDate(dateString: string, maxParts: number): string {
  const dateParts = dateString.trim().split(/\s+/).slice(0, maxParts);

  if (maxParts === 1) {
    return dateParts[0] || '';
  }

  if (maxParts === 2 && dateParts.length >= 2) {
    const day = dateParts[0];
    const month = Ext.Date.getShortMonthName(Ext.Date.getMonthNumber(dateParts[1]));
    return `${day} ${month}`;
  }

  if (maxParts === 3 && dateParts.length >= 3) {
    const day = dateParts[0];
    const month = Ext.Date.getShortMonthName(Ext.Date.getMonthNumber(dateParts[1]));
    const year = dateParts[2];
    return `${day} ${month} ${year}`;
  }

  return dateString;
}
